import VideoLocal from "../../../../components/VideoLocal/component";
import RegionInfo from "../../../../components/RegionInfo/component";
import { POSITION_MAIN } from "../../../../constants/page";
import { hashString } from "../../utils/library";
/**
 * This function handles creating the proper component structure for a My Local Swimlane
 *
 * @param {Object} params the widget params
 * @param {string} position position (main or right)
 *
 * @returns {JSX} component structure for MyLocal Swimlane
 */
export function MyLocalContainer({ params = {}, position }) {
    if (params.contentType === "video-only") {
        return <VideoLocal />;
    }
    const subjects =
        (params.displayFilter && params.displayFilter.subjectsExpression) || "";
    const excludedCategorySet =
        (params.displayFilter && params.displayFilter.excludedCategorySet) ||
        "";
    const regionInfoProps = {
        type: "flp",
        useGrid: true,
    };

    if (subjects !== "" || excludedCategorySet !== "") {
        regionInfoProps.section = `flp-localsubject-${hashString(
            JSON.stringify(params.displayFilter)
        )}`;
        regionInfoProps.subjects = subjects;
        regionInfoProps.excludedCategorySet = excludedCategorySet;
    }

    if (params?.videoSuffix) {
        regionInfoProps.pathSuffix = params.videoSuffix;
    }
    if (params?.onClick) {
        regionInfoProps.cardClickHandler = params.onClick;
    }

    return (
        <RegionInfo
            isSwimlane={position === POSITION_MAIN}
            {...regionInfoProps}
        />
    );
}
